import {
  WalletClient,
  Transport,
  Chain,
  Account,
  PublicActions,
  Hex,
  EncodeDeployDataReturnType,
} from 'viem';

export enum BeaconFactoryEvent {
  NewIdentityModule = 'NewIdentityModule',
}

export enum BeaconFactoryMethod {
  CreateNewIdentityModule = 'createNewIdentityModule',
  IdentityModuleAddress = 'identityModuleAddress',
}

export enum IdentityModuleMethod {
  GetIdentityModuleDetail = 'getIdentityModuleDetail',
  GetIdentityModuleKeyStoreDetails = 'getIdentityModuleKeyStoreDetails',
  UpdateKeyStoreContract = 'updateKeyStoreContract',
  GetKeyStoreAddresses = 'getKeyStoreAddresses',
}

export enum IdentityModuleContractEvent {
  UpdateKeyStoreContract = 'UpdateKeyStoreContract',
}

export type TWalletClient = WalletClient<Transport, Chain, Account> &
  PublicActions;

export interface GetIdentityDetailResponse {
  accountPrivateKey: Hex;
  accountPublicKey: Hex;
  agentAddress: Hex;
  salt: bigint;
  signingDid: string;
}

export interface IExecuteUserOperationRequest {
  contractAddress: Hex;
  data: EncodeDeployDataReturnType;
}

export interface IUploadFileRequest {
  file: File | (File & { previewURL: string });
  name: string;
  authToken: string;
  identityAddress: Hex;
}

export interface IRSAKeyPair {
  publicKey: string;
  privateKey: string;
}

export interface PrivateKeysJSON {
  portalAddress: Hex;
  ownerPublicKey: string;
  ownerPrivateKey: string;
  portalPublicKey: string;
  portalPrivateKey: string;
  memberPublicKey: string;
  memberPrivateKey: string;
  source: string;
}
